/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { GET_DANH_SACH_DON_HANG, GET_DANH_SACH_DON_HANG_DONE, GET_LIST_CHAT_IN_BILL, GET_TOTAL_HEADER_QUAN_LY_DON_HANG, GET_TOTAL_QUAN_LY_DON_HANG, POST_CHAT_IN_BILL, UPDATE_STATUS_ORDER } from "./constant";

export const GetQuanLyDonHangAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_DANH_SACH_DON_HANG,
    payload,
    callback
  };
};

export const GetQuanLyDonHangActionDone = (data: any) => ({
  type: GET_DANH_SACH_DON_HANG_DONE,
  payload: data
})

export const UpdateStatusOrder = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_STATUS_ORDER,
    payload,
    callback
  };
};

export const GetTotalQuanLyDonHangAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_TOTAL_QUAN_LY_DON_HANG,
    payload,
    callback
  };
};

export const GetListChatInBillAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_CHAT_IN_BILL,
    payload,
    callback
  };
};

export const PostChatInBillAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: POST_CHAT_IN_BILL,
    payload,
    callback
  };
};

export const GetTotalHeaderQuanLyDonHangAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_TOTAL_HEADER_QUAN_LY_DON_HANG,
    payload,
    callback
  };
};
